export class SaveCatalogProductResultModel {
    private _closeDialog: boolean;
    private _success : boolean;
    private _campaignSequences: number;
    private _message : string;


    constructor(closeDialog: boolean, success?: boolean, campaignSequences?: number, message= '[Empty Message]') {
        this._closeDialog = closeDialog;
        this._success = success;
        this._campaignSequences = campaignSequences;
        this._message = message;
    }

    public isSuccess() : boolean {
        return this._success;
    }


    public getMessage() : string {
        return this._message;
    }

    public isCloseDialog(): boolean {
        return this._closeDialog;
    }

    public campaignSequence(): number{
        return this._campaignSequences;
    }
}
